import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import './assets/css/styles.css'
import './assets/css/colors.css'
import './assets/css/modern-enhancements.css'
import './index.css'
import './assets/css/property-ui-upgrade.css'
import './assets/css/responsive.css'
import './assets/css/srs-brand.css'
// The foundation must follow template styles to own the global cascade.
import './design-system/index.css'
import './design-system/refined-violet.css'
import './design-system/control-consistency.css'
import './design-system/control-alignment.css'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter basename={process.env.REACT_APP_BASENAME || '/'}>
    <div id="main-wrapper" className="srs-refined-site">
      <App />
    </div>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
